import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const MetaBarContainer = styled.div`
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 10px 0;
  align-items: center;
  margin-bottom: 20px;
`;

export const Socials = styled.div``;

export const IconLink = styled.a`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 2px solid #ccc;
  display: inline-block;
  text-align: center;
  line-height: 3;
  margin-right: 5px;

  svg {
    height: 20px;
    width: auto;

    path {
      fill: #a2a2a2;
    }
  }
`;

export const Prev = styled.a`
  margin: 0 0 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 0;
  font-size: 0;
  padding: 0 25px 0 0;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    height: 8px;
    width: 8px;
    border-bottom: 3px solid #a2a2a2;
    border-left: 3px solid #a2a2a2;
    transform: rotate(45deg);
  }

  ${breakpoint('tablet')`
    font-size: 14px;
    text-transform: uppercase;
    color: #ccc;
    width: auto;
    padding: 0;

    &:after {
      display: none;
    }
  `}

  svg {
    height: 20px;
    margin-right: 10px;
  }
`;

export const Next = styled.a`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 0;
  font-size: 0;
  padding: 0 0 0 25px;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    height: 8px;
    width: 8px;
    border-bottom: 3px solid #a2a2a2;
    border-right: 3px solid #a2a2a2;
    transform: rotate(-45deg);
  }

  ${breakpoint('tablet')`
    font-size: 14px;
    text-transform: uppercase;
    color: #ccc;
    width: auto;
    padding: 0;

    &:after {
      display: none;
    }
  `}

  svg {
    height: 20px;
    margin-left: 10px;
  }
`;

export const DesktopSplit = styled.span`
  display: none;

  ${breakpoint('tablet')`
    margin: 0 15px;
    display: inline;
  `}
`;
